import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getHotelPurchasesInput,
  getHotelPurchaseInput,
  HotelPurchaseLiteModel,
  HotelPurchaseModel,
} from './model';

export function useGetHotelPurchases(
  input?: getHotelPurchasesInput,
  options?: UseQueryOptions<
    ExtendedApiResult<HotelPurchaseLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<HotelPurchaseLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getHotelPurchases', input?.params],
      () =>
        QueryFetchFunction({
          url: 'hotel-purchases',
          params: input?.params,
        }),
      options,
    ),
    HotelPurchaseLiteModel,
  );
}

export function useGetHotelPurchase(
  input?: getHotelPurchaseInput,
  options?: UseQueryOptions<ApiResult<HotelPurchaseModel>, ApiError>,
): UseQueryResult<ApiResult<HotelPurchaseModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getHotelPurchase', input?.id],
      () => QueryFetchFunction({ url: `hotel-purchases/${input?.id}` }),
      options,
    ),
    HotelPurchaseModel,
  );
}

export function getHotelPurchasesKey(input?: getHotelPurchasesInput) {
  return ['getHotelPurchases', input?.params];
}

export function getHotelPurchaseKey(input?: getHotelPurchaseInput) {
  return ['getHotelPurchase', input?.id];
}
